import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS].GET_DONE_WORKS_ALL_HAND_MADE_WORKS]: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS].GET_DONE_WORKS_ALL_HAND_MADE_WORKS,
  },
}
